import { Component, computed } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';

type ProfileTab = 'authorizations' | 'updatePassword' | 'mfa';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss'],
    standalone: false
})
export class ProfileComponent {
  private readonly tabOrder: ProfileTab[] = ['authorizations', 'updatePassword', 'mfa'];
  private readonly routeParams = toSignal(this.route.params, {
    initialValue: this.route.snapshot.params
  });
  readonly selectedTab = computed<ProfileTab>(() => this.normalizeTab(this.routeParams()?.['id']));
  readonly multifactorLabels = { removeAllBtn: '' };

  constructor(private readonly route: ActivatedRoute) {}

  private normalizeTab(tabId: string | undefined): ProfileTab {
    return this.tabOrder.includes(tabId as ProfileTab)
      ? tabId as ProfileTab
      : 'authorizations';
  }
}
